var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('admin-limits'):_c('company-limits-page')
}
var staticRenderFns = []

export { render, staticRenderFns }